import { Outlet } from "react-router-dom";
import TopStrip from "./TopStrip";

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-[var(--page-bg)]">
      <div className="max-w-[1240px] mx-auto px-4 md:px-8 pt-[calc(1.25rem+env(safe-area-inset-top))] pb-28 sm:pt-8 sm:pb-20">
        <TopStrip />
        <Outlet />
      </div>
    </div>
  );
}
